import React from 'react';
import { useSearchParams } from 'react-router-dom';
import MyLittleFunBookView from './MyLittleFunBookView';

const MyLittleFunBookWaitingScreenView = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const handleChangeChapter = () => {
    searchParams.delete('showUnit');
    searchParams.set('showUnit', 'true');
    setSearchParams(searchParams);
  };
  let showUnit = searchParams.get('showUnit') === 'true';
  return (
    <>
      {showUnit ? (
        <MyLittleFunBookView />
      ) : (
        <div className="book-my-little-fun-waitting-screen">
          <div className="waiting-screen-left">
            <div className="waiting-screen-logo" />
          </div>
          <div className="waitting-screen-img" />
          <div className="play-button" onClick={handleChangeChapter} />
          <div id="fun-1"></div>
          <div id="fun-2"></div>
          <div id="fun-3"></div>
          <div id="fun-4"></div>
        </div>
      )}
    </>
  );
};

export default MyLittleFunBookWaitingScreenView;
